import React from 'react';
import AttachmentsComponent from '../../../Elements/AttachmentsComponent';
import TabbedPage from '../../../Elements/TabbedPage';
import CreditMemoRequestDetailsInfoTab from './CreditMemoRequestDetailsInfoTab';
import LineItemCreditRequestTab from './LineItemCreditRequestTab';
import GeneralEntryLogFigma from '../../../Elements/GeneralEntryLog/GeneralEntryLogFigma';
import CommentsEntryLogDescription from '../../../Elements/CommentsEntryLogDescription';
import LogComponent from '../../../Elements/LogComponent';

export default class CreditMemoRequestDetails extends React.Component {
  static defaultProps = {};

  constructor(props) {
    super(props);
    this.state = {};
  }

  urlParams = new URLSearchParams(window.location.search);
  creditMemoRequestId = this.urlParams.get('id');

  componentDidMount() {}

  tabs = [
    { label: 'Information', id: 'info', icon: 'fa-solid fa-info', component: <CreditMemoRequestDetailsInfoTab /> },
    { label: 'Line Items', id: 'lineitems', icon: 'fa-solid fa-file-invoice', component: <LineItemCreditRequestTab /> },
    {
      label: 'Comments',
      id: 'comments',
      icon: 'fa-solid fa-comments',
      component: (
        <GeneralEntryLogFigma
          description={CommentsEntryLogDescription}
          context={{ entityTypeId: 67, entityId: this.creditMemoRequestId }}
        />
      ),
    },
    {
      label: 'Attachments',
      id: 'attachments',
      icon: 'fa-solid fa-paperclip',
      component: (
        <AttachmentsComponent
          entityTypeId={67}
          entityId={this.creditMemoRequestId}
          enableAddNew={true}
        />
      ),
    },
    {
      label: 'Logs',
      id: 'logs',
      icon: 'fa-solid fa-stream',
      component: (
        <LogComponent
          entityType='CreditMemoRequest'
          entityId={this.creditMemoRequestId}
        />
      ),
    },
  ];

  render() {
    return (
      <div className='contentwrapper'>
        <TabbedPage tabs={this.tabs} />
      </div>
    );
  }
}
